import { PageContainer } from "src/components/containers/PageContainer/PageContainer";
import { Text } from "@asayinc/component-library";

export function VotingInstruction() {
  return (
    <PageContainer>
      <Text variant="h4" sx={{ pb: 4, pt: 10, px: 10 }}>
        Voting Instructions
      </Text>
    </PageContainer>
  );
}
